( function ( _s ) {
	_s( document ).ready( () => {
		const appWidth = () => {
			window.setRootProperty(
				'--app-width',
				parseInt( document.documentElement.clientWidth ) + 'px'
			);
		};

		_s( window ).on( 'resize', () => {
			appWidth();
		} );

		appWidth();
	} );
} )( window._s );
